export function getPaymentStepKey(config) {
    if (config.openAmount === 0) {
        return 'ffl.payment.step.description.empty.state';
    }
    if (config.dunningLevel === 0) {
        return 'ffl.payment.step.description.open.amount.no.dunning';
    }
    if (config.accessRestriction) {
        return 'ffl.payment.step.description.open.amount.and.dunning.and.access.restriction';
    }
    return 'ffl.payment.step.description.open.amount.and.dunning.no.access.restriction';
}
export function getMethodStepKey(config) {
    return config.validPaymentMethod
        ? 'ffl.payment.method.step.valid.payment.method.true'
        : 'ffl.payment.method.step.valid.payment.method.false';
}
export function getPreviewKeyPaymentFirst(config) {
    return config.validPaymentMethod
        ? 'ffl.payment.step.preview.valid.payment.method.true'
        : 'ffl.payment.step.preview.valid.payment.method.false';
}
export function getPreviewKeyMethodFirst(config) {
    if (config.dunningLevel === 0) {
        return 'ffl.payment.method.step.preview.open.amount.no.dunning';
    }
    if (config.accessRestriction) {
        return 'ffl.payment.method.step.preview.open.amount.and.dunning.and.access.restriction';
    }
    return 'ffl.payment.method.step.preview.open.amount.and.dunning.no.access.restriction';
}
export function resolveScenarioKeys(config, currentFlow, isFirstOfMultipleFlows = false) {
    function getPrimaryKey() {
        switch (currentFlow) {
            case 'PAYMENT':
                return getPaymentStepKey(config);
            case 'PAYMENT_METHOD_UPDATE':
                return getMethodStepKey(config);
        }
    }
    function getPreviewKey() {
        if (!isFirstOfMultipleFlows) {
            return undefined;
        }
        switch (currentFlow) {
            case 'PAYMENT':
                return getPreviewKeyPaymentFirst(config);
            case 'PAYMENT_METHOD_UPDATE':
                return getPreviewKeyMethodFirst(config);
        }
    }
    return {
        primaryKey: getPrimaryKey(),
        previewKey: getPreviewKey(),
        footerKey: 'ffl.questions.reach.out.to.studio'
    };
}
